import { Component } from '@angular/core';
import { LeadUiUpdateService } from '../lead-ui-update.service';

@Component({
  selector: 'app-idle-screen',
  templateUrl: './idle-screen.component.html',
  styleUrl: './idle-screen.component.scss'
})
export class IdleScreenComponent {
  constructor(public readonly updates: LeadUiUpdateService) { }
}
